import { StaticImageData } from "next/image";
import React from "react";
import { Animation } from "components/animation/animation";
import {
  Banner,
  BannerText,
  BottomContainer,
  ContentContainer,
  ContentImage,
  ContentTitle,
  LoadingBar,
  LoadingCard,
  LoadingText
} from "./practice-loading.styles";
import { Icon } from "design-system/components/icon/icon";

interface PracticeLoadingProps {
  headerImage?: StaticImageData;
  title?: string;
  subtitle?: string;
  banner?: string;
}

export const PracticeLoading: React.FC<PracticeLoadingProps> = ({
  headerImage,
  title,
  subtitle,
  banner
}) => {
  return (
    <LoadingCard>
      <ContentContainer>
        {headerImage && <ContentImage src={headerImage} alt="" />}
        {title && <ContentTitle>{title}</ContentTitle>}
      </ContentContainer>

      {banner && (
        <Banner>
          <Icon name="general-info" />
          <BannerText>{banner}</BannerText>
        </Banner>
      )}

      <BottomContainer>
        {subtitle && <LoadingText>{subtitle}</LoadingText>}
        <LoadingBar aria-hidden="true">
          <Animation path="/assets-v2/animations/loading_bar.json" loop />
        </LoadingBar>
      </BottomContainer>
    </LoadingCard>
  );
};
